import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: "", redirectTo: "", pathMatch: "full" },
  {
    path: "reportefacturasclientes",
    loadChildren: "./screen/reporte-facturas-clientes/reporte-facturas-clientes.module#ReporteFacturasClientesModule",
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
